import { AllocationsView } from "@client/components/round/allocator/AllocationsView";
import AccountablesGuaranteesExplanation from "@client/components/utils/AccountablesGuaranteesExplanation";
import { MainRoot } from "@client/pages/round/allocator/Aggregator";
import { SProcessOutput } from "@lib/algoInterface/runSProcessOnRound";

export function FunderGuaranteesPage({
  results,
  readyStatus,
}: {
  results: SProcessOutput;
  readyStatus: { isReady: boolean; reasonsWhyNot: string[] };
}) {
  return (
    <MainRoot>
      {!readyStatus.isReady && (
        <div>{`Can't run round: ${readyStatus.reasonsWhyNot.join("; ")}`}</div>
      )}
      <div className="flex flex-1 flex-col select-none overflow-x-hidden">
        {results && <FundersGuaranteesView results={results} />}
      </div>
    </MainRoot>
  );
}

// Custom wrapper around AllocationsView that sets specific props
function FundersGuaranteesView({ results }: { results: SProcessOutput }) {
  // Pre-configure the AllocationsView for funders guarantees
  return (
    <div className="p-2">
      <div className="m-4">
        <h2 className="text-lg mb-4">Funder Guarantees</h2>
        <AccountablesGuaranteesExplanation />
      </div>

      <AllocationsView
        results={results}
        initialAllocationFlow="funders/recommenders"
        initialAllocationType="guarantees"
        disableViewSwitching={true}
      />
    </div>
  );
}
